import { extend } from 'vee-validate';
import { required, email, max_value, min_value, min } from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';
import intlTelInput from "intl-tel-input/build/js/intlTelInputWithUtils"

setInteractionMode('eager');

extend('email', email);
extend('required', required);
extend('max_value', max_value);
extend('min_value', min_value);
extend('min', min);

extend('password', {
    params: ['target'],
    validate(value, { target }) {
        return value === target;
    },
    message: 'Password confirmation does not match'
});

extend('isChecked', {
    getMessage(field) {
        return 'You must accept the ' + field;
    },
    validate(value) {
        return value === true;
    }
});

extend('valid_phone', {
    validate(value) {
        if (!value) {
            return true;
        }

        const input = document.createElement('input');
        const iti = intlTelInput(input, {
            initialCountry: "au",
            nationalMode: false,
            useFullscreenPopup: false,
            utilsScript: "../node_modules/intl-tel-input/build/js/utils.js",
        });
        iti.setNumber(value);

        const isValid = iti.isValidNumber();
        iti.destroy(); // Clean up
        return isValid;
    },
    message: 'Phone is not valid.'
});
